import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Calculator } from "lucide-react";

export default function Register() {
  const { register, formatApiError } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success("Cuenta creada");
      navigate("/empresas");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Error al registrarse");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-md p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded bg-blue-600 flex items-center justify-center">
            <Calculator className="w-4 h-4 text-white" />
          </div>
          <div>
            <div className="text-base font-bold tracking-tight text-slate-900">CONTAPE</div>
            <div className="text-[10px] text-slate-500">Crear cuenta</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3.5">
          <div>
            <Label className="text-[12px]">Nombre completo</Label>
            <Input data-testid="reg-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="h-9" />
          </div>
          <div>
            <Label className="text-[12px]">Email</Label>
            <Input data-testid="reg-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="h-9" />
          </div>
          <div>
            <Label className="text-[12px]">Contraseña</Label>
            <Input data-testid="reg-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6} className="h-9" />
          </div>
          <Button data-testid="reg-submit" disabled={loading} className="w-full h-9 bg-slate-900 hover:bg-slate-800 text-white">
            {loading ? "Creando..." : "Crear cuenta"}
          </Button>
        </form>
        <p className="text-[12px] text-slate-500 mt-4 text-center">
          ¿Ya tienes cuenta? <Link to="/login" className="text-blue-600 hover:underline font-medium">Inicia sesión</Link>
        </p>
      </div>
    </div>
  );
}
